<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="w1200 career_test">
			<div class="career_test_title" v-if="data.length > 0">
				<div class="flex cl_dark">
					<p class="f24px">{{name}}</p>
					<p class="f20px"><span class="cl_blue">{{cur_index+1}}</span>/{{data.length}}</p>
				</div>
				<div class="career_test_progress mat15">
					<el-progress :percentage="(cur_index+1)/data.length*100" :stroke-width="15" color="#AFA9FE"></el-progress>
				</div>
			</div>
			<div class="career_test_cont">
				<div class="career_test_list" v-for="(item,index) in data" :key="index" v-show="index == cur_index">
					<div class="career_test_list_title f18px cl_dark">{{index+1}}、{{item.name}}</div>
					<div class="career_test_list_cont f16px cl_gray mat30">
						<div class="career_test_list_item radius8 cur" v-for="(secondItem,secondIndex) in item.answer_data" :key="secondIndex"
						 :class="{'on':item.my_answer==secondItem.answer}" @click="answerCheck(secondItem.answer,index)">
							<div class="career_test_list_item_l"></div>
							<div class="career_test_list_item_r">{{secondItem.answer}}</div>
						</div>
					</div>
					<div class="career_test_list_btm tc cl_violet mat40">
						<span class="inline cur" v-if="index > 0 && item.my_answer == ''" @click="prev(index)">上一题</span>
						<span class="inline cur" v-if="item.my_answer != ''" @click="next(index)">下一题</span>
					</div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'career_test',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 0,
				data: [],
				cur_index: 0,
				id: "",
				name: "",
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			this.name = this.$route.query.name;
			this.getdetails();
		},
		methods: {
			getdetails () {
				this.$get("/api/assess/get_assess_ques_data",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					if (res.data.length > 0) {
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].my_answer = "";
						}
					}
					this.data = res.data;
				});
			},
			answerCheck (e,index) {
				this.data[index].my_answer = e;
				if (index < (this.data.length-1)) {
					this.cur_index++
				} else {
					var post_data = [];
					for (let i = 0; i < this.data.length; i++) {
						post_data.push({id: this.data[i].id, answer: this.data[i].my_answer});
					}
					post_data = JSON.stringify(post_data)
					this.$get("/api/assess/post_assess_data",{
						token: localStorage.getItem("token"),
						id: this.id,
						post_data: post_data,
					})
					.then(res => {
						this.$router.push({path: '/career_report', query: {id: res.data}, replace: true});
					});
				}
			},
			prev (e) {
				this.cur_index--
			},
			next (e) {
				this.cur_index++
			},
		},
	}
</script>

<style>
</style>
